import { Fragment } from 'react';

/**
 * @deprecated use ksyos/design-system components instead. Remove if no longer used.
 */
export function FlexColumns(props: { children: React.ReactNode[]; noGutters?: boolean; sm: 6 | 8 | 12 }) {
    return (
        <div className={props.noGutters ? 'no-gutters row' : 'row'}>
            {props.children.map((child, i) => (
                <Fragment key={i}>{child && <div className={`col-sm-${props.sm}`}>{child}</div>}</Fragment>
            ))}
        </div>
    );
}
